// Stable per-browser anonymous ID (NOT a credential).
// Used only as a non-authenticated quota-scoping key for the AI rate limits.
// Auth sessions are stored as httpOnly cookies — never in localStorage.
const KEY = "tiplingo_user_id_v1";

export function getUserId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id =
        "u_" +
        Date.now().toString(36) +
        "_" +
        Math.random().toString(36).slice(2, 10);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch (err) {
    // localStorage unavailable (strict private mode etc.) — degrade to anon ID.
    if (process.env.NODE_ENV !== "production") {
      console.warn("getUserId localStorage error:", err?.message || err);
    }
    return "u_anon";
  }
}
